<template>
    <vue-select
        :value="value"
        @input="handleInput"
        v-bind="$attrs"
        v-on="$listeners"
        :options="options"
    >
        <template v-slot:no-options="{ search, searching }">
            <template v-if="searching">
                Hittade inga resultat på <em>{{ search }}</em>.
            </template>
            <em style="opacity: 0.5;" v-else>Sök på status</em>
        </template>
    </vue-select>
</template>

<script>
import VueSelect from '@components/Wrappers/VueSelect';
import BackendRepository from '@services/repositories/BackendRepository';

export default {
    name: 'LabelBatchStatusFilter',
    components: {
        VueSelect,
    },
    props: {
        value: null,
    },
    data() {
        return {
            options: [],
        };
    },
    created() {
        BackendRepository.getLabelBatchStatuses().then((res) => {
            this.options = res;
        });
    },
    methods: {
        handleInput(value) {
            this.$emit('input', value);
        },
    },
};
</script>
